/**
 * @ngdoc controllers
 * @memberof mercury.modules.settings
 * @name TimeStaffAddPosCtrl
 */
angular.module('mercury.modules.settings.company')
.controller('SettingsCompanyViewPermissionsCtrl', ["companyInfo", "$scope", function(companyInfo, $scope) {
  // excuse the weird variable naming here - it's to get around the text-transform css
  $scope.company = companyInfo;

  $scope.permissionList = {
      'Manager': 'Has ability to add/remove users from a Company, and set permissions',
      'Report': 'Can view Point of Sale reports',
      'Cashup': 'Can edit Cashups',
      'Stock': 'Can use the Stock module',
      'StockShare': 'Can share, and manage shared items between Companies',
      'Time': 'Can view and edit Timeclocks, and Rosters',
      'Payroll': 'Can view staff payrates in the Time module',
      'Salary': 'Can view the pay rates of Salaried staff members in the Time module'
    };
}]);
